import { Controller } from '@hotwired/stimulus';

// Used in: School show for each timetable (targets and actions in Band overview, band space) partials and show school timetables partial (used as slug link for schools)
// Purpose: Toggle timetable information for admins and for schools as schools should not get all the information of admins
// Explanation: When user clicks 'admin view', all student information is shown, on 'school view', less information is shown
// Refactor: The two functions basically do that same thing, could have a single toggle function

export default class extends Controller {
  static targets = [
    'adminView', // Targets that contain information only meant for admins
    'adminTab', // Admin view tab
    'schoolTab', // School view tab
  ];
  connect() {
    console.log('timetable toggle view controller connected');
  }
  schoolView() {
    // Change active tab and hide all admin view targets
    this.schoolTabTarget.classList.remove('inactive-tab');
    this.schoolTabTarget.classList.add('active-tab');
    this.adminTabTarget.classList.add('inactive-tab');
    this.adminTabTarget.classList.remove('active-tab');
    this.adminViewTargets.forEach((info) => info.classList.add('hidden'));
  }
  adminView() {
    // Change active tab and show all admin view targets
    this.schoolTabTarget.classList.add('inactive-tab');
    this.schoolTabTarget.classList.remove('active-tab');
    this.adminTabTarget.classList.remove('inactive-tab');
    this.adminTabTarget.classList.add('active-tab');
    this.adminViewTargets.forEach((info) => info.classList.remove('hidden'));
  }
}
